var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import commonmark from "commonmark";
import * as React from "react";
import styled from "styled-components";
import { SpaciousTypography } from "./styleComponents";

var MarkdownText = function MarkdownText(_a) {
  var children = _a.children,
      text = _a.text,
      _b = _a.Component,
      Component = _b === void 0 ? SpaciousTypography : _b,
      removeParagraphs = _a.removeParagraphs,
      others = __rest(_a, ["children", "text", "Component", "removeParagraphs"]);

  var reader = new commonmark.Parser();
  var writer = new commonmark.HtmlRenderer();
  var toBeWritten = reader.parse(children || text || "");
  var html = writer.render(toBeWritten);

  if (removeParagraphs) {
    html = html.replace(/<p>/g, "<div>");
    html = html.replace(/<\/p>/g, "</div>");
  }

  return React.createElement(Component, __assign({
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, others));
};

export default styled(MarkdownText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  p,\n  pre {\n    margin-top: 0;\n  }\n"], ["\n  p,\n  pre {\n    margin-top: 0;\n  }\n"])));
var templateObject_1;